import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { TrackClick } from '@g4/trackster';
import { hook } from '@g4/automation-hooks';
import PrintAware from '../../../components/PrintAware';

import LOGO from '../../../images/logo-allegiant-white.svg';
import BLUE_LOGO from '../../../images/logo-allegiant-blue.svg';

const StyledLogo = styled.img`
  display: block;
  height: ${props => props.logoHeight}px;
  padding: ${props => props.theme.spacing(2)} 0;
  transition: height 0.2s ease-in-out;
`;

const PrintLogo = styled(StyledLogo)`
  display: none;
  @media print {
    display: block;
  }
`;

StyledLogo.propTypes = {
  logoHeight: PropTypes.number,
};

StyledLogo.defaultProps = {
  logoHeight: 70,
};

const Logo = ({
  logoHeight,
  automationHook,
  isStadium,
  allegiantStadiumPackageLogo,
}) => (
  <TrackClick
    action="Logo"
    category="site_click_tracking"
    label="Allegiant Air - Cheap Flights, Air + Hotel Packages, Discounted Car Rentals"
  >
    <a href="/" aria-label="Go to home page" {...hook(automationHook)}>
      <PrintAware>
        {isStadium ? (
          <StyledLogo
            alt=""
            logoHeight={logoHeight}
            src={allegiantStadiumPackageLogo?.path}
          />
        ) : (
          <StyledLogo alt="" logoHeight={logoHeight} src={LOGO} />
        )}
      </PrintAware>
      <PrintLogo alt="" logoHeight={logoHeight} src={BLUE_LOGO} />
    </a>
  </TrackClick>
);

Logo.propTypes = {
  logoHeight: PropTypes.number,
  automationHook: PropTypes.string,
  isStadium: PropTypes.bool,
  allegiantStadiumPackageLogo: PropTypes.object,
};

Logo.defaultProps = {
  logoHeight: 70,
};

export default withTheme(Logo);
